export interface Btn {
  label: string;
  action: () => any;
  loading?: boolean;
  disabled?: boolean;
}

export const useButton = (btn: Btn) => {
  return {
    onClick: () => {
      if (btn.loading || btn.disabled) {
        return;
      }
      btn.action?.();
    }
  };
};
